<template>
  <input
    class="form-input w-full rounded-md border-bg-1 bg-bg-1 px-2 pb-[5px] pt-[6px] text-center text-[11px] font-medium leading-4 text-gpx_black-500 placeholder:text-gpx_gray-200 focus:border-none focus:bg-white focus:outline-none focus:ring-1 focus:ring-gpx_gray-700 placeholder-shown:focus:text-gpx_gray-200"
    max-length="3"
  />
</template>

<script setup></script>
